<script setup lang="ts">
import PasswordInput from "~/components/Pages/Auth/steps/PasswordInput.vue";
import { useAuthStore } from "~/store/auth/auth.store";
import { storeToRefs } from "pinia";
import { useAuthValidation } from "~/composables/auth/useAuthValidation";

const authStore = useAuthStore();
const { connexion } = storeToRefs(authStore);
const authValidation = useAuthValidation();
const $e = authValidation.stepRegisterPassword();

const inputPassword = ref();

async function validate() {
  return $e.value.$validate();
}

function resetValidation() {
  $e.value.$reset();
}

defineExpose({ validate, resetValidation });

onMounted(() => {
  if (inputPassword.value?.inputPassword) {
    inputPassword.value.inputPassword.focus();
  }
});
</script>

<template>
  <div class="grid gap-[16px]">
    <div class="connexion__form_input_container">
      <label for="password" class="body_regular text-secondary-color">Mot de passe *</label>
      <PasswordInput
        id="password"
        ref="inputPassword"
        v-model="connexion.registerPasswordFirst"
        placeholder="********"
      ></PasswordInput>
    </div>

    <div v-if="$e.$error" class="validator__container">
      <span>
        <img
          v-if="$e.$errors.some((x) => x.$validator === 'mustContainMinLength')"
          src="/icons/emojis/cancel.svg"
          alt=""
        />
        <img v-else src="/icons/emojis/check.svg" alt="" />
        <span class="meta">8 caractères minimum</span>
      </span>
      <span>
        <img
          v-if="$e.$errors.some((x) => x.$validator === 'mustContainOneNumber')"
          src="/icons/emojis/cancel.svg"
          alt=""
        />
        <img v-else src="/icons/emojis/check.svg" alt="" />
        <span class="meta">1 chiffre minimum</span>
      </span>
      <span>
        <img
          v-if="$e.$errors.some((x) => x.$validator === 'mustContainLowercase')"
          src="/icons/emojis/cancel.svg"
          alt=""
        />
        <img v-else src="/icons/emojis/check.svg" alt="" />
        <span class="meta">1 lettre minuscule minimum</span>
      </span>
      <span>
        <img
          v-if="$e.$errors.some((x) => x.$validator === 'mustContainUppercase')"
          src="/icons/emojis/cancel.svg"
          alt=""
        />
        <img v-else src="/icons/emojis/check.svg" alt="" />
        <span class="meta">1 lettre majuscule minimum</span>
      </span>
      <span>
        <img
          v-if="$e.$errors.some((x) => x.$validator === 'mustContainSpecialChar')"
          src="/icons/emojis/cancel.svg"
          alt=""
        />
        <img v-else src="/icons/emojis/check.svg" alt="" />
        <span class="meta">1 caractère spécial minimum (&, @, $, % , etc)</span>
      </span>
    </div>

    <div class="connexion__form_input_container">
      <label for="password_confirm" class="body_regular text-secondary-color">Confirmez votre mot de passe *</label>
      <PasswordInput
        id="password_confirm"
        v-model="connexion.registerPasswordConfirm"
        placeholder="********"
      ></PasswordInput>
      <span v-if="$e.$errors.some((x) => x.$validator === 'required')" class="text-primary-red-color body_regular">
        Ce champ est obligatoire
      </span>
      <span
        v-else-if="$e.$errors.some((x) => x.$validator === 'sameAsPassword')"
        class="text-primary-red-color body_regular"
      >
        Les deux mots de passe sont différents.
      </span>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "assets/scss/texts";

.validator__container {
  & > * {
    @extend .meta;
    @apply flex gap-[12px] items-center;
  }

  img {
    width: 12px;
    height: 12px;
  }
}
</style>
